import AttendanceTable from './AttendanceTable';

export default AttendanceTable;
